import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { copyFor } from '../../copy/copy';

const FacebookIcon = props => (
    <svg
        width={props.isMobileResolution ? 52 : 36}
        height={props.isMobileResolution ? 52 : 36}
        viewBox="0 0 36 36"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>{copyFor('icons', 'facebook')}</title>
        <path
            d="M18.91 26.308h-3.377v-7.963h-1.687v-2.743h1.687v-1.648c0-2.238.953-3.57 3.66-3.57h2.253v2.745h-1.408c-1.054 0-1.124.384-1.124 1.1l-.004 1.373h2.552l-.3 2.743H18.91v7.963z"
            fillRule="evenodd"
            fill="#000"
        />
    </svg>
);

FacebookIcon.propTypes = {
    isMobileResolution: PropTypes.bool.isRequired
};

export default connect(
    state => ({
        isMobileResolution: state.widget.isMobileResolution
    }),
    {}
)(FacebookIcon);



// WEBPACK FOOTER //
// ./src/components/Svg/FacebookIconFooter.jsx